<template>
  <div v-if="$site.location" class="w-screen bg-secondary flex flex-col">
    <a href="#content" class="fixed -left-full z-[5000] p-2 m-6 rounded border-white bg-black text-white focus:left-1/2 focus:-translate-x-1/2">Skip to main content</a>

    <LayoutElementsAppBar />

    <div id="main" class="relative overflow-y-auto overflow-x-hidden flex-grow flex-shrink sm:pt-20">
      <LayoutElementsNavigation />

      <slot />

      <LayoutElementsFooter/>
    </div>

    <LayoutElementsMobile />

    <LayoutElementsMenu />

    <client-only>
      <LayoutElementsCookie v-if="$site.settings?.showCookieConsent" layout="site" />
    </client-only>

    <div id="bookappCustomScriptBody" class="hidden" />
  </div>
</template>

<script setup lang="ts">
const { $site, $postscribe } = useNuxtApp()

useHead(() => {
  const bookappCustomScriptHead = $site?.settings?.bookappCustomScriptHead || ''

  return {
    htmlAttrs: {
      class: 'layout-default'
    },
    bodyAttrs: {
      class: 'bg-secondary'
    },
    script: [
      {
        type: 'text/javascript',
        innerHTML: bookappCustomScriptHead
      }
    ],
    __dangerouslyDisableSanitizers: ['script']
  }
})

onMounted(() => {
  if ($site.settings.bookappCustomScriptBody) {
    // const postscribe = require('postscribe')
    $postscribe('#bookappCustomScriptBody', $site.settings.bookappCustomScriptBody)
  }
})
</script>

<style>
html.layout-default {
  height: -webkit-fill-available;
  height: 100%
}

.layout-default body {
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
  height: 100%
}

.layout-default #__nuxt {
  height: 100%
}

.layout-default #__layout {
  height: 100%
}

@supports (-webkit-touch-callout: none) {
  .h-screen {
    height: -webkit-fill-available;
  }
}

.slide-left-leave-active {
  transition: 0.2s;
}
.slide-left-enter-active {
  transition: 0.3s;
}
.slide-left-enter {
  transform: translate(20%, 0);
  opacity: 0
}

.slide-left-enter, .slide-left-enter-active {
}

.slide-left-leave, .slide-left-leave-active {
}

.slide-left-leave-to {
  transform: translate(-20%, 0);
  opacity: 0
}

.slide-left-enter-to {
  opacity: 1
}

.slide-right-leave-active
{
  transition: 0.2s;
}
.slide-right-enter-active
{
  transition: 0.3s;
}
.slide-right-enter {
  transform: translate(-20%, 0);
  opacity: 0
}

.slide-right-enter, .slide-right-enter-active {
}

.slide-right-leave, .slide-right-leave-active {
}

.slide-right-leave-to {
  transform: translate(20%, 0);
  opacity: 0
}

.slide-right-enter-to {
  opacity: 1
}
</style>
